var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1192",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.889099 0.336849C0.642015 0.602405 0.5 1.01113 0.5 1.54225V20.4337C0.5 20.9648 0.642015 21.3736 0.898335 21.6299L0.965302 21.6865L11.5506 11.1011V10.8633L0.956065 0.280273L0.889099 0.336849Z",
    fill: "url(#paint0_linear_2579_2577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1203",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 14.6434L11.5415 11.1115V10.8644L15.0734 7.33252L15.1496 7.37986L19.3269 9.75371C20.5231 10.428 20.5231 11.5387 19.3269 12.2222L15.1496 14.5961C15.1485 14.5961 15.0723 14.6434 15.0723 14.6434Z",
    fill: "url(#paint1_linear_2579_2577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1210",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1489 14.5964L11.5419 10.9883L0.889648 21.6406C1.27875 22.0585 1.9334 22.1059 2.66542 21.6972L15.1489 14.5964Z",
    fill: "url(#paint2_linear_2579_2577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1223",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1489 7.38107L2.66542 0.289546C1.93456 -0.128417 1.27875 -0.0718421 0.889648 0.346121L11.5408 10.988L15.1489 7.38107Z",
    fill: "url(#paint3_linear_2579_2577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1225",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0722 14.52L2.6742 21.5642C1.98145 21.9625 1.36374 21.9348 0.965404 21.5734L0.898438 21.6404L0.965404 21.697C1.36374 22.0572 1.98145 22.0861 2.6742 21.6877L15.1577 14.5962L15.0722 14.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1227",
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3253 12.099L15.0625 14.5202L15.1387 14.5964L19.316 12.2225C19.9141 11.8808 20.2085 11.4351 20.2085 10.9883C20.1704 11.397 19.8668 11.7861 19.3253 12.099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1229",
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66487 0.413249L19.3257 9.87862C19.8672 10.1823 20.1708 10.5806 20.2182 10.9893C20.2182 10.5437 19.9238 10.0968 19.3257 9.75508L2.66487 0.289708C1.46871 -0.393813 0.5 0.175403 0.5 1.54244V1.66598C0.5 0.298944 1.46871 -0.261034 2.66487 0.413249Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2579_2577",
    x1: 10.6001,
    y1: 1.33918,
    x2: -6.35575,
    y2: 5.85709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2579_2577",
    x1: 20.8835,
    y1: 10.9885,
    x2: 0.209394,
    y2: 10.9885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2579_2577",
    x1: 13.1875,
    y1: 12.9511,
    x2: -0.424693,
    y2: 35.8614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2579_2577",
    x1: -1.7918,
    y1: -5.94734,
    x2: 4.28104,
    y2: 4.28476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.5f4e645b190717a567b0d03ecf69b00d.svg";
export { ForwardRef as ReactComponent };